import Ionicons from "@expo/vector-icons/build/Ionicons";
import * as Haptics from "expo-haptics";
import React from "react";
import { Platform, StyleSheet, TouchableOpacity, View } from "react-native";

const shouldUseHaptics = Platform.OS === "ios";

const size = 64;
const slop = 40;

const hitSlop = { top: slop, bottom: slop, right: slop, left: slop };

export default function FooterButton({
	onPress,
	isActive = false,
	iconName,
	iconSize = 36,
}) {
	const tint = isActive ? "default" : "dark";
	const iconColor = isActive ? "#4e9bde" : "#fff";

	const onPressIn = React.useCallback(() => {
		if (shouldUseHaptics)
			Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
	}, []);

	const onPressButton = React.useCallback(() => {
		onPress();
		if (shouldUseHaptics)
			Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
	}, [onPress]);

	return (
		<View style={styles.container}>
			<TouchableOpacity
				hitSlop={hitSlop}
				onPressIn={onPressIn}
				onPress={onPressButton}
			>
				<Ionicons name={iconName} size={iconSize} color={iconColor} />
			</TouchableOpacity>
		</View>
	);
}

const styles = StyleSheet.create({
	container: {
		width: size,
		height: size,
		borderRadius: size / 2,
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: "#989a9c",
		opacity: 0.8,
	},
});
